import { Controller } from '@hotwired/stimulus';

// Sizes are applied through CSSOM because inline style attributes are blocked by the CSP.
export default class extends Controller {
  static values = { width: String, height: String };

  widthValueChanged() {
    if (this.widthValue) this.element.style.width = this.widthValue;
  }

  heightValueChanged() {
    if (this.heightValue) this.element.style.height = this.heightValue;
  }
}
